import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';

import { getCategoryIcon } from './Icons';
import css from './SectionCategories.module.css';

/**
 * Category browsing cards, built from the Listing Categories configured in
 * Sharetribe (Console → Listings → Categories).
 *
 * Cards link into the marketplace search using the structured category param
 * (`pub_categoryLevel1`), so a click lands on exactly the listings filed under
 * that category — and categories added in Console later show up here with no
 * code change. Nothing renders if no categories are configured yet.
 */
const SectionCategories = props => {
  const { categories = [], categoryKey = 'categoryLevel' } = props;

  if (categories.length === 0) {
    return null;
  }

  return (
    <section className={css.root}>
      <div className={css.inner}>
        <div className={css.heading}>
          <h2 className={css.title}>
            <FormattedMessage
              id="LandingPage.categories.title"
              defaultMessage="Browse by category"
            />
          </h2>
          <p className={css.subtitle}>
            <FormattedMessage
              id="LandingPage.categories.subtitle"
              defaultMessage="Find products with verified sustainability credentials across every part of your life."
            />
          </p>
        </div>

        <ul className={css.grid}>
          {categories.map(({ id, name }) => {
            const Icon = getCategoryIcon(id, name);
            return (
              <li key={id} className={css.item}>
                <NamedLink
                  name="SearchPage"
                  to={{ search: `?pub_${categoryKey}1=${encodeURIComponent(id)}` }}
                  className={css.card}
                >
                  <span className={css.iconWrap}>
                    <Icon className={css.icon} />
                  </span>
                  <span className={css.label}>{name}</span>
                </NamedLink>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default SectionCategories;
